import React,{useEffect,useState,useRef} from 'react';
import { Link } from 'react-router-dom'
import { Form, Container, Row, Col } from "react-bootstrap";
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';
// import "antd/dist/antd.css";
import 'antd/dist/antd.min.css';
import {BASE_URL} from '../../lib/constant';
import { Select, Input, Table, Space, Button } from "antd";
import CustomTable from './CustomTable';

const ContractDetails = () => { 
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [contractDetails, setContractDetails] = useState(false);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const searchValue = useRef('');
    const filter = useRef({});
    const lastUrl = useRef({});
    const orderBy = useRef('');

    const [editPermission, setEditPermission] = useState(false);

    const [cSearchBy, setcSearchBy] = useState('matname');
    const [cSearchByType, setcSearchByType] = useState('text');
    const [cSearchByFilter, setcSearchByFilter] = useState('contain');
    const [cSearchValue, setcSearchValue] = useState('');

    const seachByOption = [
        {label: 'Name', value:'matname', type:'text'},
        {label: 'Contract price', value:'contractprice', type:'number'},
        {label: 'Selling price', value:'sellingprice', type:'number'}
    ];

    const nonStringColoums = [
        'sellingprice','contractprice'
    ];

    const searchFilterOptions = [
        {label: 'Contain', value:'contain', for:'text'},
        {label: 'Equal', value:'equal',for:'number'},
        {label: 'Greater Than', value:'gte',for:'number'},
        {label: 'Less Than', value:'lte',for:'number'},
      ];

    const [searchFilter, setSearchFilter] = useState(searchFilterOptions.filter(x=>x.for ==='text'));
    const resetSearchFilter = (e)=>{
        if(['number','date'].includes(seachByOption.filter(x=>x.value==e)[0].type)){
          var options=searchFilterOptions.filter(x=>x.for ==='number');
          setSearchFilter(options);
          setcSearchByFilter(options[0].value);
        }else{
          var options=searchFilterOptions.filter(x=>x.for ==='text');
          setSearchFilter(options);
          setcSearchByFilter(options[0].value);
        }
      }

    const getContractDetails = async (queryString,reset) => {
        const ctrnum=searchParams.get("ctrnum");//'SGS2022';
        const arnum=AuthVerify.getUser().arnum;//'ARM-90195171';//
        // Get Contract Details
        // api/corporate/contract/:arnum/:ctrnum
        // api/corporate/contract/ARM-22000075/SGS2022_1?sortby=matnum&orderby=desc&filter=matnum,contain,P&filter=matname,contain,KA&limit=1&offset=1
        let filterQuery=''
        if(cSearchBy && cSearchByFilter && cSearchValue!='' && !reset){
            if(seachByOption.filter(x=>x.value==cSearchBy)[0].type=='date'){
              filterQuery+=`&filter=${cSearchBy},${cSearchByFilter},'${cSearchValue}'`;
            }
            else{
              filterQuery+=`&filter=${cSearchBy},${cSearchByFilter},${cSearchValue}`;
            }
            
          }
        let url=`/corporate/contract/${arnum}/${ctrnum}?${queryString}${filterQuery}${orderBy.current??''}`;
        if(lastUrl.current!=url){
            lastUrl.current=url;
        }else{
            return;
        }
        await Axios.get(url)
        .then(function (response) {
            if (response && response.data?.data && response.data.data?.items) {
                var data=[];
                setTotal(response.data.data?.items?.count);
                let items=response.data.data?.items?.items;
                if(items && items.length>0){
                    items.forEach(item=>{
                        data.push({
                            imageurl: item.imageurl,
                            matname: item.matname,
                            sellingprice: item.sellingprice,
                            contractprice: item.contractprice,
                            matnum: item.matnum
                        })
                    })
                    setItems(data);
                }
                else{
                    setItems([]);
                }
                if(!contractDetails){
                    setContractDetails(response.data.data);
                }
                
            }
            else {
                setItems([]);
            }
        })
        .catch(function (error) { 
          console.log(error)
          setItems([]);
        });
    };
    

    useEffect(async () => {
        setEditPermission(AuthVerify.getPermissions("MyContracts")?.edit);
        getContractDetails(`limit=${pageSize}&offset=${page}`);
    }, [searchParams])

    useEffect(async () => {
        getContractDetails(`limit=${pageSize}&offset=${page}`);
    }, [pageSize,page])

    // #region Custom table
    const [items, setItems] = useState(false);

    const handleChange = (pagination, filters, sorter) => {
        let offset = (pagination.current * pagination.pageSize) - pagination.pageSize;
        const limit = pagination.pageSize;
        const params = {};
      
        if (sorter.hasOwnProperty("column")) {
        //   params.order = { field: sorter.columnKey, dir: sorter.order };
            if(sorter.order){
                let newOrder = `&sortby=${sorter.columnKey}&orderby=${sorter.order.replaceAll('end','')}`
                if(orderBy.current!=newOrder){
                    params.order=newOrder;
                    pagination.current=1;
                }
            }
            else params.order='';
        }
        setPageSize(limit);
        setPage(pagination.current);
        orderBy.current=params.order??'';
        filter.current=filters;
        getContractDetails(`limit=${limit}&offset=${offset}`);
        // console.log(params,filters,sorter);
        // console.log(params);
    };
    
    const columns = [
        {
          title: 'Product',
          dataIndex: 'imageurl',
          key: 'imageurl',
          render: (text) => <a href="#">
          <img src={BASE_URL+text} alt="Product" /></a>,
        },
        {
          title: 'Description',
          key: 'matname',
          dataIndex: 'matname',
          sorter: {
            compare: (a, b) => a.matname + b.matname
          },
          render: (_, record) => (
            <>
            <p className="product-name">
                <Link to={"/product-detail?matnum="+record.matnum}>{record.matname}</Link>
            </p>
            <small className="cart_ref">Matnum: {record.matnum}</small><br />
          </>
          )
        },
        {
          title: 'Contract price',
          dataIndex: 'contractprice',
          key: 'contractprice',
        //   sorter:(a,b)=> {return a.contractprice>b.contractprice},
          sorter: {
            compare: (a, b) => a.contractprice - b.contractprice
          }
        },
        {
            title: 'Selling Price',
            key: 'sellingprice',
            dataIndex: 'sellingprice',
            sorter: {
                compare: (a, b) => a.sellingprice - b.sellingprice
            }
        },
        {
          title: 'Action',
          key: 'action',
          render: (_, record) => (
            <Space size="middle">
              <a>Print{record.name}</a>|
              <a>Export</a>
            </Space>
          ),
        },
    ];

    //#endregion
    

    return (
        <section className="main-container col1-layout">
            <div className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                {contractDetails && 
                                    <div className="box-border" style={{margin:"auto", maxWidth:"80%"}}>
                                        <h2>Contract Details</h2>
                                        <h3 className="checkout-sep" style={{ paddingBottom: "10px" }}>Contract No. {contractDetails?.contract?.ctrnum ?? 'N/A'}</h3>
                                        <h5><strong>Contract name:</strong> {contractDetails?.contract?.ctrname ?? 'N/A'}</h5>
                                        <h5><strong>Start Date:</strong> {contractDetails?.contract?.startdate ?? 'N/A'}</h5>
                                        <h5><strong>End Date:</strong> {contractDetails?.contract?.enddate ?? 'N/A'}</h5>
                                        <CustomTable/>
                                        <div className="">
                                            <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button" onClick={()=>navigate('/my-account?activeKey=Contracts')}><span>Back to My Contracts</span></button>
                                        </div>
                                        <br/>
                                        <br/>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </section >

    )
}

export default ContractDetails